import { render, staticRenderFns } from "./ResourceTags.vue?vue&type=template&id=7eeb9876&scoped=true"
import script from "./ResourceTags.vue?vue&type=script&lang=js"
export * from "./ResourceTags.vue?vue&type=script&lang=js"
import style0 from "./ResourceTags.vue?vue&type=style&index=0&id=7eeb9876&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eeb9876",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7eeb9876')) {
      api.createRecord('7eeb9876', component.options)
    } else {
      api.reload('7eeb9876', component.options)
    }
    module.hot.accept("./ResourceTags.vue?vue&type=template&id=7eeb9876&scoped=true", function () {
      api.rerender('7eeb9876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/ambience/ResourceTags.vue"
export default component.exports